import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0A0A0C]" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12">
      <Logo testId="footer-logo" />
      <p className="font-tech text-xs uppercase tracking-[0.2em] text-zinc-500">
        Mon – Fri · 8AM – 12PM · 1PM – 5PM · 5PM – 9PM
      </p>
      <p className="text-xs text-zinc-600">© {new Date().getFullYear()} Riot Factory</p>
    </div>
  </footer>
);
